import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const MEDIA = (u) => {
    if (!u) return "";
    if (u.startsWith("http")) return u;
    if (u.startsWith("/api/uploads") || u.startsWith("/uploads")) {
        const path = u.startsWith("/api") ? u : `/api${u}`;
        return `${BACKEND_URL}${path}`;
    }
    return u;
};

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach JWT from localStorage if present
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("st_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default api;
